import { render, staticRenderFns } from "./ApproximateDateItem.vue?vue&type=template&id=389ae374&"
import script from "./ApproximateDateItem.vue?vue&type=script&lang=js&"
export * from "./ApproximateDateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports